<div [class.disabled]="disabled || userAccess === false" [formGroup]="frmGroup" [hidden]="this.frmGroup.get(this.configData.name)['hidden']" class="dhl-componentsswitcheslabel-v2 paddingrght_15">
  <div fxLayout="row" fxFlex="100%" fxLayoutAlign="{{(configData.direction === 'rtl' ? 'end end' : ' center')}}" dir="{{(configData.direction ? configData.direction : 'ltr')}}">
    <div class="toggle-label-outer">
      <label class="dhl-switch-label-v2">
        {{configData.label | translate}}
        <span *ngIf="configData.required" class="required">*</span>
      </label><br>
    </div>
    <div class="toggle-button-outer">
      <label class="dhl-switch-v2">
        <input [formControlName]="$safeNavigationMigration(configData?.name)" type="checkbox" [checked]="!!configData?.dynamicVisibility?.setValues?.ngTrueValue  ? (dynamicChecked || configData?.dynamicVisibility?.setValues?.ngTrueValue === frmGroup.get(configData.name).value) : frmGroup.get(configData.name).value" [disabled] = "configData.disabled" [required]="configData.required"
        (change)="onCommonEventHander('TOGGLE', $event); inputValueTypeFn($safeNavigationMigration($event?.target?.checked));" >
        <span class="dhl-slider-v2 dhl-round-v2" [ngClass]="{'toggle-readonly' : $safeNavigationMigration(configData?.disabled)}"> </span>
      </label>
      <span *ngIf = "secondaryValue" class="secondaryValue"> Last updated {{this.secondaryValue}} ago </span>
    </div>
  </div>
  <!-- <div width="33%">
    <label class="dhl-switch-label-no-v2">&nbsp;No</label><br>
  </div> -->
</div>

<div class="form-field-hint" *ngIf="configData?.hintText" [hidden]="this.frmGroup.get(this.configData.name)['hidden']">
  <span class="hint">{{configData.hintText}}</span>
</div>
<div class="toggle-hint" *ngIf="toggleHintText">
  <span _ngcontent-jra-c317="" class="error-icon"><img _ngcontent-jra-c317="" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))" class="dhl-input-error-icon"></span>
  <span>{{toggleHintText}}</span>
</div>
<!-- CP4624 - end -->

<div class="form-field-hint" *ngIf="configData.enableDynamicHintText && dynamicHintToggle">
  <span>
    <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2260,24,24))" class="info-icon" type="image/svg+xml"/>
  </span>
  <span class="hint">{{configData.dynamicHintText}}</span>
</div>
<!-- commenting below code as we don't need to show validation msg for toggle because default value will always
be there as false -->
<div class="dhl-slidetoggle-errMsg-v2" *ngIf="frmGroup?.get($safeNavigationMigration(configData?.name))?.errors?.groupValidationError">
  <br>
  {{$safeNavigationMigration(frmGroup.get(configData.name)?.errors?.groupValidationError) | translate}}
</div>
